import { Injectable } from '@angular/core';
import { EventSponsor } from './event-sponsor.model';
import { IEventV4SponsorsService } from './ievent-v4-sponsor.service';
import { EventsServiceApiService } from 'src/app/shared/api/events-service-api.service';

@Injectable({
  providedIn: 'root',
})
export class EventV4SponsorsService implements IEventV4SponsorsService {
  private _eventServiceBaseUrl: string = '/event/v2/sponsor/';

  public constructor(private _eventApiService: EventsServiceApiService) {}

  public getEventEventSponsors(eventId: number): Promise<Array<EventSponsor>> {
    let options = this._eventApiService.getDefaultApiCacheOptionsForFrequentlyChangedData();
    options.CacheSeconds = 5;
    let url: string = `${this._eventServiceBaseUrl}event/${eventId}/search?PageSize=0&PageNumber=0&OrderBy=Sort:asc`;
    return this._eventApiService.get(url, options);
  }

  public getEventEventSponsor = (sponsorId: number): Promise<EventSponsor> => {
    return this._eventApiService.get(this._eventServiceBaseUrl + sponsorId);
  };

  public upsertEventSponsor = (eventSponsor: EventSponsor): Promise<number> => {
    let url: string = `${this._eventServiceBaseUrl}upsert`;
    return this._eventApiService.post(url, eventSponsor).then((data: number): Promise<number> => {
      return Promise.resolve(data);
    });
  };

  public deleteEventSponsor = (eventSponsorId: number): Promise<void> => {
    let url: string = this._eventServiceBaseUrl + eventSponsorId.toString();
    return this._eventApiService.delete(url).then((): Promise<void> => {
      return Promise.resolve();
    });
  };

  public reorderEventSponsors = (eventId: number, sponsors: Array<EventSponsor>): Promise<void> => {
    if (!sponsors || !eventId) {
      return Promise.resolve();
    }

    let url = `${this._eventServiceBaseUrl}event/${eventId}/order-sponsors`;
    let sponsorIds = sponsors.map<any>((sponsor) => {
      return sponsor.SponserId;
    });

    return this._eventApiService.post(url, sponsorIds).then((): Promise<void> => {
      return Promise.resolve();
    });
  };
}
